import { AxiosInstance } from 'axios';
import { createContextAwareHandlers } from './instance';

export interface ShippingParams {
  activity: string;
  type: string;
  size: number;
  lca: 'WTW' | 'TTW';
  km: number;
  weight: number;
}

export const getShippingFootprint = (instance: AxiosInstance) => async (params: ShippingParams): Promise<PercapitaOffset> => {
  const { data } = await instance.get<PercapitaOffset>('/footprint/shipping/', {
    params,
  });

  return data;
};

export const getShippingMetadata = (instance: AxiosInstance) => async (): Promise<ShippingMetadata> => {
  const { data } = await instance.get<ShippingMetadata>('/metadata/shipping');

  return data;
};

const handlers = {
  getShippingFootprint,
  getShippingMetadata,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createShippingApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};

export default createShippingApi;
